__turbopack_context__.v({
  "auto-complete": "_1OQSeq_auto-complete",
  "card": "_1OQSeq_card",
  "clear": "_1OQSeq_clear",
  "closeIcon": "_1OQSeq_closeIcon",
  "historyTitle": "_1OQSeq_historyTitle",
  "list": "_1OQSeq_list",
  "listItem": "_1OQSeq_listItem",
  "searchHistory": "_1OQSeq_searchHistory",
  "searchText": "_1OQSeq_searchText",
  "searchWord": "_1OQSeq_searchWord",
  "wrapper": "_1OQSeq_wrapper",
});
